//
//
//
//
//
//
//

export default {
  name: 'qrcode'
}



// WEBPACK FOOTER //
// ./src/components/qrcode.vue